<template>
  <aside>
      <div class="me">
        <svg width="280" height="335" viewBox="0 0 280 335">

          <path fill="black" d="M0 0 L 0 280 L 280 335 L 280 65 L 0 0" />

          <defs>
              <clipPath id="me">
                  <path d="M0 0 L 0 280 L 280 335 L 280 65 L 0 0" />
              </clipPath>
          </defs>

          <image xlink:href="../assets/me.jpg" clip-path="url(#me)" />
        </svg>
      </div>

      <header>
          Hello,<br>
          <h1>I am <span class="primary">Jakub Kotek</span>.</h1>
          A {{ old }}ms <br>
          old PROGRAMMER.
      </header>

      <p class="info">
        I love <span class="vue">VueJS</span>.<br>
        I like <span class="nette">Nette</span>.<br>
        I do <span class="react">ReactJS</span> and <span class="laravel">Laravel</span>.
      </p>

      <p class="contact">
        Write me something nice.<br>
        <strong><a href="mailto:info@jakubkotek.cz">info@jakubkotek.cz</a></strong><br><br>

        Feel free to send me any amount of money.<br>
        <strong>CZ9320100000002000819840</strong><br><br>

        Do you prefer suitcase? No problem.<br>
        <strong>Antonína Slavíčka 39, 56802, Svitavy, CZ</strong><br><br>

        IN: 04205227
      </p>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      old: new Date().getTime() - new Date("1991-04-04").getTime()
    };
  },

  created() {
    setInterval(() => {
      this.old = new Date().getTime() - new Date("1991-04-04").getTime();
    }, 240);
  }
};
</script>

<style>
header {
  font-size: 2.2em;
}

h1 {
  font-size: 1em;
}

.me {
  margin-bottom: -30px;
}

@media all and (max-width: 768px) {
  .me {
    display: none;
  }
}

.info {
  margin-top: 30px;
  font-size: 1.3em;
  color: #565656;
}

.contact {
  font-size: 1em;
  color: #828282;
  margin-top: 30px;
}

.contact a {
  color: #828282;
}

.vue {
  color: var(--vue);
}

.react {
  color: var(--react);
}

.nette {
  color: var(--nette);
}

.laravel {
  color: var(--laravel);
}
</style>
